class LyShowroomCollectionUrlParametersResolver extends HTMLElement {
    connectedCallback() {
        const params = new URLSearchParams(location.search)
        // 经度
        this.lng = params.get('lng')
        // 纬度
        this.lat = params.get('lat')
    }

    get inSearchMode() {
        return !!this.lng && !!this.lat
    }
}

if (!customElements.get('ly-showroom-collection-card')) {
    customElements.define('ly-showroom-collection-card', class extends LyShowroomCollectionUrlParametersResolver {

        MAX_MILES = 250

        async connectedCallback() {
            super.connectedCallback()

            this.distanceEl = this.querySelector('.distance-text')
            this.timeEl = this.querySelector('.time-text')
        }

        runSearch = async () => {
            const { distance, duration } = await this.search()

            // ✅ 转换米 → 英里
            const miles = distance / 1609.34
            const milesText = `${miles.toFixed(1)} mi`

            // ✅ 转换秒 → 小时 + 分钟
            const hours = Math.floor(duration / 3600)
            const minutes = Math.floor((duration % 3600) / 60)

            let timeText = ''
            if (hours > 0) {
                timeText += `${hours}h `
            }
            timeText += `${minutes}m`

            // ✅ 显示格式化内容
            this.distanceEl.textContent = milesText
            this.timeEl.textContent = timeText

            // ✅ 比较距离，超出范围则隐藏
            this.classList.toggle('ly-hide', miles > this.MAX_MILES)
            this.classList.toggle('valid-result', miles <= this.MAX_MILES)
            this.dataset.distance = distance
        }

        search = async () => {
            if (!this.inSearchMode) return

            const lng1 = parseFloat(this.lng)
            const lat1 = parseFloat(this.lat)
            const lng2 = parseFloat(this.dataset.roomLng)
            const lat2 = parseFloat(this.dataset.roomLat)

            if (!lng1 || !lat1 || !lng2 || !lat2) return

            await google.maps.importLibrary('routes')

            // 确保 Google Maps 脚本已加载
            if (!window.google || !google.maps) {
                console.error('Google Maps JS API 未加载')
                return
            }

            // 初始化 DistanceMatrixService
            const service = new google.maps.DistanceMatrixService()

            return new Promise((resolve, reject) => {
                service.getDistanceMatrix(
                    {
                        origins: [new google.maps.LatLng(lat1, lng1)],
                        destinations: [new google.maps.LatLng(lat2, lng2)],
                        travelMode: google.maps.TravelMode.DRIVING,
                        unitSystem: google.maps.UnitSystem.IMPERIAL
                    },
                    (response, status) => {
                        if (status !== 'OK') {
                            console.error('DistanceMatrix 失败:', status)
                            return reject(response)
                        }

                        const result = response.rows[0].elements[0]
                        if (result.status === 'OK') {
                            return resolve({
                                distance: result.distance.value,
                                duration: result.duration.value
                            })
                        }
                        reject(response)
                    }
                )
            })
        }
    })
}

if (!customElements.get('ly-showroom-collection-card-wrapper')) {
    customElements.define('ly-showroom-collection-card-wrapper', class extends LyShowroomCollectionUrlParametersResolver {

        connectedCallback() {
            super.connectedCallback()

            this.featuredTitle = this.dataset.featuredTitle
            this.resultTitle = this.dataset.resultTitle

            this.titleEl = this.querySelector('.ly-showroom-collection-card-wrapper-title')
            this.cards = [...this.querySelectorAll('ly-showroom-collection-card')]

            this.run()
        }

        run = async () => {
            if (!this.inSearchMode) return
            const stopSearchingAnimation = this.startSearchingAnimation(this.titleEl)
            this.cards.map(card => card.classList.add('ly-hide'))
            try {
                await Promise.allSettled(this.cards.map(card => card?.runSearch()))
            } catch (error) {
                console.error('某些卡片搜索出错：', error)
            } finally {
                stopSearchingAnimation()
                this.sortCards()
                this.updateTitle()
            }
        }

        startSearchingAnimation(targetEl, text = 'Searching') {
            if (!targetEl) return () => { }

            let dots = 0
            let lastTime = 0
            const interval = 400 // 每 400ms 切换一次
            let frameId = null
            let stopped = false

            const animate = (timestamp) => {
                if (stopped) return
                if (!lastTime) lastTime = timestamp

                const delta = timestamp - lastTime
                if (delta >= interval) {
                    dots = (dots + 1) % 4 // 0~3 循环
                    targetEl.textContent = text + '.'.repeat(dots)
                    lastTime = timestamp
                }

                frameId = requestAnimationFrame(animate)
            }

            frameId = requestAnimationFrame(animate)

            // ✅ 返回取消函数
            return () => {
                stopped = true
                if (frameId) cancelAnimationFrame(frameId)
            }
        }

        updateTitle() {
            this.titleEl.textContent = this.inSearchMode ? `${this.searchResultCount} ${this.resultTitle}` : this.featuredTitle
        }

        get searchResultCount() {
            return this.cards.filter(card => !card.classList.contains('ly-hide')).length
        }

        sortCards = () => {
            this.cards.forEach(card => {
                const dist = parseFloat(card.dataset.distance || 'Infinity')
                card.style.order = dist
            })
        }
    })
}